import FlowFieldBackground from '../landing/FlowFieldBackground';
import Footer from '../Footer';

/** Footer-only bridge — shared flow lines + gradient into band, no top seam. */
export default function MarketingFooterBridge() {
  return (
    <div className="marketing-footer-bridge">
      <FlowFieldBackground
        gradientId="marketing-footer-flow-grad"
        preset="hero"
        fadeIn={false}
        uniformStroke
      />
      <div className="relative z-[2]">
        <Footer embedded />
      </div>
    </div>
  );
}
